import React from "react";

// Local Libraries
import phrasebookLoad from "../../../../i18n";

//components
import { Table } from "../../../../components/SkyFramework/Tables/Table";
import { PaginationBar } from "../../../../components/SkyFramework/Pagination/PaginationBar.jsx";
// Constants
const phrasebook = phrasebookLoad();

export default class SelectProduct extends React.Component {
  render() {
    const { serviceNumberTypes, nextStep, prevStep } = this.props;
    if (serviceNumberTypes.data) {
      if (serviceNumberTypes.count > 0) {

        var labels = [
          phrasebook.services.service,
          phrasebook.profile.jurisdiction,
          phrasebook.profile.jurisdiction_dial_code,

          phrasebook.common.option,
          phrasebook.references.currency,
          phrasebook.pricing.nrc,
          phrasebook.pricing.mrc
        ];
        var fields = ['service_type', 'jurisdiction', 'jurisdiction_dial_code', 'vendor_option', ['tariff', 'currency'], ['tariff', 'nrc'], ['tariff', 'mrc']]
        var actions = [
          {
            label: phrasebook.common.select,
            type: "form",
            onClick: nextStep,
          },
        ];
        if (['DID', 'SIP Trunking'].includes(serviceNumberTypes.data[0].service_type)) {
          labels.splice(2, 0, phrasebook.numbers.number_type);
          labels.splice(2, 0, phrasebook.references.cities);


          fields.splice(2, 0, 'number_type');
          fields.splice(2, 0, ['cities', ['city']]);
        }

        return (
          <>
            {serviceNumberTypes.data[0].service_type === 'UIFN' ? <div class="alert alert-warning"><p>{phrasebook.orders.uifn_itu} </p></div> : null}
            <Table
              values={serviceNumberTypes.data}
              nofound={phrasebook.common.nodatafound}
              headers={labels}
              keys={fields}
              actions={actions}
              action_key={"id"}
            />
            <PaginationBar
              limit={10}
              total={serviceNumberTypes.count}
              currentPage={0}
              onPageChanged={this}
            // pageNeighbours={this.state.pageNeighbours}
            />
            <div className="box-actions-footer">
              <button className="btn btn-main" onClick={prevStep}>
                {phrasebook.common.previous}
              </button>
            </div>
          </>
        );
      } else return null;
    } else return null;
  }
}
